
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const withAuthProtection = (Component) => {
  return (props) => {
    const { currentUser, isLoading } = useAuth();

    // If it's still loading, we don't know if the user is authenticated yet.
    if (isLoading) {
      return <div>Loading...</div>; // Or whatever loading indicator you'd like
    }

    // If we're not loading and there is no user, redirect to login
    if (!currentUser?.accessToken) {
      return <Navigate to="/login" />;
    }

    // If we're not loading and the user is authenticated, render the component
    return <Component {...props} />;
  };
};

export default withAuthProtection;
